import React, {Component} from 'react';
import Form from './form';
import request from '../request';

export default class NoteForm extends Component {
 constructor(props) {
   super(props);
   let {note} = props;
   this.state = {note};
   this.onChange = this.onChange.bind(this);
  }

  submit() {
    this.setState({submitting: true});
    let {patient_id, onSubmit, return_path} = this.props;
    let {note} = this.state;
    let url = `/admin/patients/${patient_id}/notes`;
    let method;
    if (note.id) {
      url += '/' + note.id;
      method = 'PUT';
    } else {
      method = 'POST';
    }

    request(method, url, {note})
      .then(note => {
        if (onSubmit) {
          onSubmit(note);
        } else if (return_path) {
          window.location = return_path;
        }
      })
      .catch(({errors}) => {
        this.setState({errors, submitting: false});
      });
  }

  onChange(note) {
    this.setState({note});
  }

  fields() {
    return [
      {name: 'description', type: 'text'},
    ];
  }

  render() {
    let {note, submitting, errors} = this.state;
    let {onCancel} = this.props;
    return <Form model_name="Note" fields={this.fields()} model={note} errors={errors} onChange={this.onChange} onSubmit={e => this.submit(e)} onCancel={onCancel} submitting={submitting} />
  }
}
